(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/deposit-restriction/assets/javascripts/react/components/age-check.js') >= 0) return;  svs.modules.push('/components/accountservices/deposit-restriction/assets/javascripts/react/components/age-check.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const _svs$accountservices$ = svs.accountservices.deposit_restriction,
  data = _svs$accountservices$.data,
  RadioButtons = _svs$accountservices$.RadioButtons,
  DepositRestrictionDialogs = _svs$accountservices$.DepositRestrictionDialogs,
  DepositRestriction = _svs$accountservices$.DepositRestriction;
const AgeCheck = () => {
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    numberOfDeposits = _useState2[0],
    setNumberOfDeposits = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitted = _useState4[0],
    setIsSubmitted = _useState4[1];
  const restrictions = useRef(null);
  useEffect(() => {
    if (!restrictions.current) {
      restrictions.current = new DepositRestriction();
    } else {
      restrictions.current.reloadElements();
    }
  }, []);
  const handleSubmit = e => {
    e.preventDefault();
    setIsSubmitted(true);
    if (numberOfDeposits === null) {
      return;
    }
    DepositRestrictionDialogs.showSetDepositLimitsDialog(numberOfDeposits, data === null || data === void 0 ? void 0 : data.isPnp);
  };
  return React.createElement("section", {
    className: "align-center padding-1"
  }, React.createElement("div", {
    className: "panel-wrapper js-deposit-restriction bg-white margin-top-2 inline-block"
  }, React.createElement(Icon, {
    icon: "deposit-limits",
    size: "700"
  }), React.createElement("h2", {
    className: "margin-top-3 f-550"
  }, "T\xE4nk p\xE5 att du redan har satt in pengar flera g\xE5nger idag - genomsnittet \xE4r en g\xE5ng."), React.createElement(Form, {
    "aria-live": "polite",
    className: "error-class",
    id: "js-deposit-restriction-form",
    onSubmit: handleSubmit
  }, React.createElement("fieldset", null, React.createElement("legend", {
    className: "js-form-legend-deposit-restriction w100 margin-top-3 margin-bottom-3"
  }, "Hur m\xE5nga fler g\xE5nger vill du kunna s\xE4tta in", React.createElement("br", null), "pengar idag?"), React.createElement(ControlGroup, {
    errorMessage: "G\xF6r ett val innan du sparar",
    hasError: isSubmitted && numberOfDeposits === null,
    v2: true
  }, React.createElement(RadioButtons, {
    isAdult: data === null || data === void 0 ? void 0 : data.isAdult,
    isPnp: data === null || data === void 0 ? void 0 : data.isPnp,
    isSubmitted: isSubmitted,
    selectedValue: numberOfDeposits,
    setIsSubmitted: setIsSubmitted,
    setNumberOfDeposits: setNumberOfDeposits
  })), React.createElement(Button, {
    "aria-label": "Spara val av ins\xE4ttningsgr\xE4ns",
    block: true,
    className: "deposit-restriction-submit js-deposit-restriction-submit margin-top-2 margin-bottom-2",
    focus: true,
    size: 300,
    type: "submit"
  }, "Spara")))));
};
svs.accountservices.deposit_restriction.AgeCheck = AgeCheck;

 })(window);